import React from 'react';
import CarouselScreen from '../../../components/CarouselScreen';
import tdSphere from '../../../assets/images/td_sphere.png';

function PresentingComplaintIntro() {
  const slides = [
    {
      title: "Your Current Concerns",
      content: [
        "This section helps us understand why you are asking for an ADHD assessment and what challenges you're facing in your daily life.",
        "Your answers will give us a clearer picture of your experiences and how these problems affect you.",
        "Everything you tell us is kept private and will only be used for your care."
      ],
      ctaText: "Go to Questions",
      route: "/forms/your-current-concerns"
    },
    {
      title: "How to Complete This Form",
      content: [
        "Take your time to answer each question thoughtfully - there's no rush.",
        "We've included explanations for some questions. Look for the (?) icon if you need more information.",
        "You can save your progress and return to complete this section later.",
        "If you feel uncertain about any questions, it's okay to leave them blank."
      ],
      ctaText: "Go to Questions",
      route: "/forms/your-current-concerns"
    }
  ];

  return (
    <div className="min-h-screen">
      <div className="h-10 md:h-40 w-full fixed top-0 left-0 z-10">
        <div className="absolute inset-0 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-200 opacity-80"></div>
      </div>
      <CarouselScreen 
        slides={slides}
        bgColor="bg-violet-900"
        logo={tdSphere}
        logoAlt="ThinkDivergent Sphere"
        showBackButton={true}
      />
    </div>
  );
}

export default PresentingComplaintIntro;